export default __webpack_public_path__ + "static/media/S2-vid1.1a5d0ebb.mp4";